import { render, staticRenderFns } from "./ExibePerfilPage.vue?vue&type=template&id=c0d71f3c&scoped=true"
import script from "./ExibePerfilPage.vue?vue&type=script&lang=js"
export * from "./ExibePerfilPage.vue?vue&type=script&lang=js"
import style0 from "./ExibePerfilPage.vue?vue&type=style&index=0&id=c0d71f3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d71f3c",
  null
  
)

export default component.exports